export default __webpack_public_path__ + "static/media/PayCheck.7cba242f5d5d050dcc5fa4d91c65cf50.webp";